import { Moon, Sun } from 'lucide-react';

const STORAGE_KEY = 'hyredocs.dashboard.theme';

export function readStoredTheme() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function storeTheme(theme) {
  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* ignore */
  }
}

export default function ThemeToggle({ theme, onToggle }) {
  const dark = theme === 'dark';
  return (
    <button
      type="button"
      className="dash-btn"
      onClick={onToggle}
      aria-label={dark ? 'Switch the dashboard to light mode' : 'Switch the dashboard to dark mode'}
      title={dark ? 'Light mode' : 'Dark mode'}
      data-testid="dashboard-theme-toggle"
    >
      {dark ? <Sun className="w-3.5 h-3.5" /> : <Moon className="w-3.5 h-3.5" />}
      <span className="hidden sm:inline">{dark ? 'Light' : 'Dark'}</span>
    </button>
  );
}
